<template>
	<select :id='id' v-model="selected" class='form-control table-control my-control' data-num='f_20' data-table='1' disabled>
		<option v-for="option in options" :value='option.id'>
			{{ option.name }}
		</option>
	</select>
</template>

<script>
	import {DB} from './../../../constants'
	const LOCALFORESTRY = 'localforestrie_list.php'
	const HEADER = 'get_header.php'
	const LOCATION = 'get_conclusion_location.php'

	import {EventBus} from '../../../lib/EventBus'
	
	export default {
		name: 'localforestry',
		data: function () {
			return {
				selected: '0',
				options: [],
				id: `${this.type}_localforestry_${this.line_count}`,
			}
		},
		props: {
			line_count: 0,
			type: ''
		},
		created: function () {
			fetch(DB + HEADER + '?id=' + this.$parent.selected_act, {
				credentials: 'include'
			})
			.then(res => res.json())
			.then(res => {
				return res[2].val
			})
			.then(id => {
				fetch(DB + LOCALFORESTRY + '?id=' + id)
				.then(data => data.json())
				.then(data => {
					if (data) {
						this.options = [{id: '0', name: ''}, ...data];
					}
					else {
						this.selected = '0'
						this.options = []
					}
				})
				.then(() => {
					fetch(DB + LOCATION + '?id=' + this.$route.params.id, {
						credentials: 'include'
					})
					.then(res => res.json())
					.then(res => {
						const lf = res.filter(item => {
							return item.field == 'f_20'
						})

						this.selected = lf[this.line_count] ? lf[this.line_count].val : '0'
					})
					.catch(err => console.log('1',err))
				})
				.catch(err => console.log('2',err))
			})
			.catch(err => console.log('3',err))
		}

	}
</script>


// WEBPACK FOOTER //
// localforestry.vue?2504adf0